const generalCreateMarkup = (body) => {
  return { __html: body };
};

const useCreateMarkup = () => {
  const createMarkup = (value) => generalCreateMarkup(value);

  return { createMarkup };
};

export default useCreateMarkup;
